import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _assetsAnimationLoading_gray_slowGif from "../../../../assets/animation/loading_gray_slow.gif";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useRef, useMemo, useEffect } from 'react';
import { View, Text, Image, StyleSheet, TouchableOpacity, Pressable, Platform, ActionSheetIOS, DeviceEventEmitter } from 'react-native';
import { launchImageLibrary } from 'react-native-image-picker';
import CloseLine from '../../../Image/rn/CloseLine';
import Picture from '../../../Image/rn/Picture';
import AddIcon from '../../../Image/rn/AddIcon';
import MediaDelete from '../../../Image/rn/MediaDelete';
import UploadFailed from '../../../Image/rn/UploadFailed';
import { ImagePicker } from '@shopee/react-native-sdk';
import { brand, gray_3, gray_5, WindowWidth } from '../../../../styles/rn';
import { ModeType } from '..';
import { useTracking } from '../../../../hooks/rn/useTracking';
import { useLocale } from '../../../LocaleProvider/rn';
import MediaSelect from './MediaSelect';
import { addFileProtocol, filterNullObj, formatMediaTokens } from '../config';
import { IMAGE_TYPE, MediaConstants, MediaSelectType, MediaSourceType, UPLOAD_VIDEO_ERROR_STATUS, UploadMediaResStatus, UploadMediaStatus, VIDEO_TYPE } from '../common';
import { dataMaintainer } from '../../../../components/ConfigProvider/rn/context';
import { TRACKING_OPERATION } from '../../../../utils/tracking/constants';
/* eslint-disable @typescript-eslint/no-var-requires */

var module = {
  exports: {}
};
var exports = module.exports;
var Loading = _assetsAnimationLoading_gray_slowGif; // FILE_NAME

var FILE_NAME = 'Inhouse_Form_File'; // media的间隔是 12px 需要注意左右都有 margin

export var MIX_MEDIA_MARGIN_RIGHT = 12; // 一行可以放下三个 media

export var MIX_MEDIA_IN_ROW_COUNT = 3; // 根据设备宽度设置 media 宽度

var MIX_MEDIA_WIDTH = (WindowWidth - (MIX_MEDIA_IN_ROW_COUNT + 1) * MIX_MEDIA_MARGIN_RIGHT) / MIX_MEDIA_IN_ROW_COUNT;
export var styles = StyleSheet.create({
  pictureUploadWrapper: {
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  pictureUploadItemWrapper: {
    width: 88,
    height: 88,
    borderWidth: 1,
    borderStyle: 'dashed',
    borderColor: gray_5
  },
  mediaUploadItemWrapper: {
    width: MIX_MEDIA_WIDTH,
    height: MIX_MEDIA_WIDTH,
    borderWidth: 1,
    borderStyle: 'dashed',
    borderColor: gray_5,
    borderRadius: 4,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  pictureUploadIcon: {
    width: 24,
    height: 24,
    marginTop: 24,
    marginLeft: 30
  },
  mediaUploadIconWrapper: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  mediaUploadIcon: {
    width: 16,
    height: 16
  },
  mixedmediaUploadIcon: {
    width: 24,
    height: 24
  },
  pictureUploadText: {
    color: gray_5,
    textAlign: 'center',
    paddingTop: 4,
    paddingRight: 4
  },
  mediaUploadText: {
    color: gray_3,
    textAlign: 'center',
    paddingTop: 8,
    paddingHorizontal: 2,
    fontSize: 12,
    lineHeight: 14
  },
  mediaUploadWithEnquiredText: {
    color: gray_3,
    textAlign: 'center',
    fontSize: 12,
    lineHeight: 14
  },
  mediaUploadWithEnquired: {
    color: brand,
    paddingLeft: 2
  },
  imageWrapper: {
    position: 'relative',
    marginRight: 8,
    marginBottom: 8
  },
  mediaWrapper: {
    position: 'relative',
    marginRight: 8,
    marginBottom: 8,
    borderRadius: 4
  },
  maskWrapper: {
    width: 88,
    height: 88,
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0,0,0,0.4)',
    zIndex: 1
  },
  mediaMaskWrapper: {
    width: MIX_MEDIA_WIDTH,
    height: MIX_MEDIA_WIDTH,
    position: 'absolute',
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0,0,0,0.4)',
    zIndex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  mediaLoadingMaskWrapper: {
    backgroundColor: 'rgba(0,0,0,0.05)'
  },
  mediaLoadingIcon: {
    width: 32,
    height: 32
  },
  mediaFailedIcon: {
    width: 32,
    height: 32
  },
  failedIcon: {
    width: 32,
    height: 32,
    marginTop: 25,
    marginLeft: 30
  },
  failedIconWrapper: {
    width: 26,
    height: 26
  },
  failedText: {
    color: 'white',
    textAlign: 'center',
    marginTop: -5
  },
  mediaFailedText: {
    color: 'white',
    textAlign: 'center',
    marginTop: 5
  },
  imageItem: {
    width: 88,
    height: 88
  },
  mediaItem: {
    width: MIX_MEDIA_WIDTH,
    height: MIX_MEDIA_WIDTH
  },
  imageRemoveIconWrapper: {
    width: 16,
    height: 16,
    position: 'absolute',
    top: 0,
    right: 0,
    backgroundColor: 'rgba(0,0,0,0.4)',
    paddingTop: 2,
    paddingBottom: 2,
    paddingLeft: 2,
    paddingRight: 2,
    zIndex: 2
  },
  mediaRemoveIconWrapper: {
    width: 24,
    height: 24,
    position: 'absolute',
    top: 0,
    right: 0,
    backgroundColor: 'rgba(0,0,0,0.4)',
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 4,
    paddingRight: 4,
    zIndex: 2
  },
  imageRemoveIcon: {
    width: 12,
    height: 12
  },
  mediaRemoveIcon: {
    width: 16,
    height: 16
  },
  warningText: {
    fontSize: 12,
    lineHeight: 14,
    color: 'rgba(0, 0, 0, 0.87)'
  },
  warningWrapper: {
    marginTop: 4,
    paddingVertical: 8,
    paddingHorizontal: 12,
    backgroundColor: '#FFF8E4',
    borderRadius: 1
  }
});
export var SelectType;
(function (SelectType) {
  SelectType[SelectType["Gallery"] = 0] = "Gallery";
  SelectType[SelectType["Photos"] = 1] = "Photos";
  SelectType[SelectType["File"] = 2] = "File";
})(SelectType || (SelectType = {}));
export var FileType;
(function (FileType) {
  FileType[FileType["File"] = 1] = "File";
  FileType[FileType["Image"] = 2] = "Image";
  FileType[FileType["Video"] = 3] = "Video";
})(FileType || (FileType = {}));
export var MediaType;
(function (MediaType) {
  MediaType[MediaType["Image"] = 1] = "Image";
  MediaType[MediaType["Video"] = 2] = "Video";
})(MediaType || (MediaType = {}));
export var UploadStatus;
(function (UploadStatus) {
  UploadStatus[UploadStatus["Loading"] = 0] = "Loading";
  UploadStatus[UploadStatus["Fail"] = 1] = "Fail";
  UploadStatus[UploadStatus["Success"] = 2] = "Success";
})(UploadStatus || (UploadStatus = {}));

// 将base64转换为文件对象
export function dataURLtoFile(dataurl, filename) {
  var arr = dataurl.split(',');
  var mime = arr[0].match(/:(.*?);/)[1];
  var bstr = atob(arr[1]);
  var n = bstr.length;
  var u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {
    type: mime
  });
} // 将url转换为文件对象

function getFileFromUrl(url, fileName) {
  return {
    uri: url,
    name: fileName,
    type: 'image/jpeg'
  };
}
export var FileUpload = function FileUpload(props) {
  var _props$getCurRootTag;
  var _props$value = props.value,
    value = _props$value === void 0 ? [] : _props$value,
    maxFileSize = props.maxFileSize,
    maxFileNum = props.maxFileNum,
    fileTypeAccepted = props.fileTypeAccepted,
    callback = props.callback,
    postVideoPreUpload = props.postVideoPreUpload,
    sessionId = props.sessionId,
    mode = props.mode,
    onChange = props.onChange,
    _props$isCaseCreation = props.isCaseCreation,
    isCaseCreation = _props$isCaseCreation === void 0 ? false : _props$isCaseCreation;
  var rootTag = Number((_props$getCurRootTag = props.getCurRootTag) === null || _props$getCurRootTag === void 0 ? void 0 : _props$getCurRootTag.call(props));
  var _useLocale = useLocale(),
    trans = _useLocale.trans;
  var _React$useState = React.useState(value),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    originFileList = _React$useState2[0],
    setOriginFileList = _React$useState2[1]; // 还未上传成功的图片列表

  var originFileListRef = useRef();
  var _useTracking = useTracking({
      trackingData: _objectSpread({}, props.trackingData)
    }),
    tracker = _useTracking.tracker,
    trackingClick = _useTracking.trackingClick;
  var handleIOSActionSheet = function handleIOSActionSheet(maxCount, actionCallback) {
    ActionSheetIOS.showActionSheetWithOptions({
      options: ['Cancel', 'Camera', 'Photos'],
      cancelButtonIndex: 0
    }, function (buttonIndex) {
      if (buttonIndex === 0) {
        return;
      } else if (buttonIndex === 1) {
        nativeUpload(maxCount, actionCallback, SelectType.Photos);
      } else if (buttonIndex === 2) {
        nativeUpload(maxCount, actionCallback, SelectType.Gallery);
      }
    });
  };
  var handleOpenActionSheet = function handleOpenActionSheet(maxCount, actionCallback) {
    Platform.OS === 'ios' ? handleIOSActionSheet(maxCount, actionCallback) : nativeUpload(maxCount, actionCallback, SelectType.Gallery);
  };
  var handleRemove = function handleRemove(index, file) {
    var newFileList = _toConsumableArray(originFileList);
    newFileList.splice(index, 1);
    setOriginFileList(newFileList);
    if (!(file !== null && file !== void 0 && file.url)) {
      return;
    }
    var newValue = _toConsumableArray(value); // 查找 value 中对应的 index

    var valueIndex = newValue.findIndex(function (item) {
      return item.url === file.url;
    });
    newValue.splice(valueIndex, 1); // fix 一种偶现情况 newValue中存在 null

    onChange === null || onChange === void 0 ? void 0 : onChange(newValue.filter(function (item) {
      return !!item;
    }));
  };
  var showUploadIcon = useMemo(function () {
    if ([ModeType.View].includes(props.mode)) {
      return false;
    }
    if (maxFileNum && originFileList.length >= maxFileNum) {
      return false;
    }
    return true;
  }, [maxFileNum, mode, originFileList]);
  var anchorRef = useRef(null);
  var handleRetry = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(index, fileInfo) {
      var file, newFileList, preUploadResult, res, _newFileList, newValue, _newFileList2;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              Platform.OS === 'web' && trackingClick && tracker.click(_objectSpread(_objectSpread({}, trackingClick), {}, {
                data: _objectSpread({}, (trackingClick === null || trackingClick === void 0 ? void 0 : trackingClick.data) || {})
              }));
              if (!(fileInfo.uploadStatus === UploadStatus.Loading)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              file = fileInfo.uri;
              newFileList = _toConsumableArray(originFileList);
              newFileList[index] = _objectSpread(_objectSpread({}, fileInfo), {}, {
                uploadStatus: UploadStatus.Loading
              });
              setOriginFileList(newFileList); // 对视频的重新上传

              if (!(isCaseCreation && fileInfo.type === MediaType.Video)) {
                _context.next = 14;
                break;
              }
              _context.next = 10;
              return postVideoPreUpload === null || postVideoPreUpload === void 0 ? void 0 : postVideoPreUpload({
                amount: 1,
                channel: 1,
                sessionId: sessionId
              });
            case 10:
              preUploadResult = _context.sent;
              _context.next = 13;
              return handleVideoTokenResponse(preUploadResult, [fileInfo.id]);
            case 13:
              return _context.abrupt("return");
            case 14:
              _context.next = 16;
              return callback === null || callback === void 0 ? void 0 : callback({
                file: file
              });
            case 16:
              res = _context.sent;
              if (res !== null && res !== void 0 && res.file_name && res !== null && res !== void 0 && res.url) {
                _newFileList = _toConsumableArray(originFileList);
                _newFileList[index] = _objectSpread({}, res);
                setOriginFileList(_newFileList);
                newValue = _toConsumableArray(value);
                newValue[index] = {
                  file_name: res.file_name,
                  url: res.url
                };
                onChange === null || onChange === void 0 ? void 0 : onChange(newValue.filter(function (item) {
                  return !!item;
                }));
              } else {
                _newFileList2 = _toConsumableArray(originFileList);
                _newFileList2[index] = _objectSpread(_objectSpread({}, fileInfo), {}, {
                  uploadStatus: UploadStatus.Fail
                });
                setOriginFileList(_newFileList2);
              }
            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function handleRetry(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var handleUpload = function handleUpload() {
    var actionCallback = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(assets, maxCount) {
        var newAssets, resList, newFileList, fileList, uploadSuccess, uploadFailed;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!assets.length) {
                  _context2.next = 11;
                  break;
                }

                // 可能会选中的张数会多于 maxFileNum，要裁减一下
                newAssets = assets.slice(0, maxCount - value.length);
                _context2.next = 4;
                return Promise.all(newAssets.map(function (file) {
                  return callback === null || callback === void 0 ? void 0 : callback({
                    file: file
                  }); // }
                  // return callback?.({ asset });
                }));

              case 4:
                resList = _context2.sent;
                newFileList = [];
                fileList = resList // @ts-ignore
                .map(function (item, index) {
                  if (item !== null && item !== void 0 && item.file_name && item !== null && item !== void 0 && item.url) {
                    newFileList[index] = _objectSpread({}, item);
                    return {
                      file_name: item.file_name,
                      url: item.url
                    };
                  } else {
                    newFileList[index] = {
                      uri: newAssets[index],
                      uploadStatus: UploadStatus.Fail
                    };
                  }
                }).filter(function (item) {
                  return item !== undefined;
                });
                uploadSuccess = newFileList.filter(function (item) {
                  return item.url;
                });
                uploadFailed = newFileList.filter(function (item) {
                  return !item.url;
                });
                setOriginFileList([].concat(_toConsumableArray(originFileList), _toConsumableArray(uploadSuccess), _toConsumableArray(uploadFailed)));
                onChange === null || onChange === void 0 ? void 0 : onChange([].concat(_toConsumableArray(value), _toConsumableArray(fileList)).filter(function (item) {
                  return !!item;
                }));
              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return function actionCallback(_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }();
    var maxCount = maxFileNum || 9;
    if (isCaseCreation) {
      nativeMediaUpload(maxCount);
      return;
    }
    Platform.OS === 'web' ? webUpload(maxCount, actionCallback) : handleOpenActionSheet(maxCount, actionCallback);
  };
  var webUpload = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(maxCount, actionCallback) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              trackingClick && tracker.click(_objectSpread(_objectSpread({}, trackingClick), {}, {
                data: _objectSpread({}, (trackingClick === null || trackingClick === void 0 ? void 0 : trackingClick.data) || {})
              }));
              launchImageLibrary({
                mediaType: 'photo',
                selectionLimit: maxCount
              }, function (response) {
                var assets = response === null || response === void 0 ? void 0 : response.assets.map(function (i) {
                  return dataURLtoFile(i.uri, FILE_NAME);
                });
                actionCallback(assets, maxCount);
              });
            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function webUpload(_x5, _x6) {
      return _ref3.apply(this, arguments);
    };
  }();
  var addMediasListener = function addMediasListener(callback) {
    var _MediaSelect$mediaSta;
    MediaSelect === null || MediaSelect === void 0 ? void 0 : (_MediaSelect$mediaSta = MediaSelect.mediaStartListeningForUploadProgress) === null || _MediaSelect$mediaSta === void 0 ? void 0 : _MediaSelect$mediaSta.call(MediaSelect, rootTag);
    DeviceEventEmitter.addListener('MEDIA_SELECT_UPLOAD_PROGRESS_EVENT', function (res) {
      var _originFileListRef$cu, _originFileListRef$cu2;
      var result = {};
      try {
        result = JSON.parse(res);
      } catch (error) {}
      var taskData = (_originFileListRef$cu = originFileListRef.current) === null || _originFileListRef$cu === void 0 ? void 0 : _originFileListRef$cu.find(function (item) {
        return item.id === result.id;
      });
      if ((taskData === null || taskData === void 0 ? void 0 : taskData.status) === result.status // 数据没有变更，return
      ) {
        return;
      } // 处理视频数据

      var _result = result,
        id = _result.id,
        status = _result.status,
        progress = _result.progress,
        videoCoverUrl = _result.videoCoverUrl,
        videoFilePath = _result.videoFilePath,
        videoUrl = _result.videoUrl,
        uploadCostTime = _result.uploadCostTime;
      var updateData = filterNullObj({
        id: id,
        status: status,
        progress: progress && typeof progress === 'number' ? progress / 100 : 0,
        coverUrl: videoCoverUrl,
        videoFilePath: videoFilePath,
        url: videoUrl,
        uploadCostTime: uploadCostTime,
        type: MediaType.Video,
        file_name: FILE_NAME,
        uploadStatus: UPLOAD_VIDEO_ERROR_STATUS.includes(status) ? UploadStatus.Fail : status === UploadMediaStatus.UploadSucceed ? UploadStatus.Success : UploadStatus.Loading
      });
      var newFile = (_originFileListRef$cu2 = originFileListRef.current) === null || _originFileListRef$cu2 === void 0 ? void 0 : _originFileListRef$cu2.map(function (item) {
        return item.id === id ? _objectSpread(_objectSpread({}, item), updateData) : item;
      });
      originFileListRef.current = newFile;
      callback(newFile);
    });
  }; // 处理 获取token接口响应

  var handleVideoTokenResponse = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(res, videoIds) {
      var formatTokens, startUploadPromises, startUploadResults;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              formatTokens = formatMediaTokens(res.data); // 开始上传

              startUploadPromises = videoIds.map(function (videoId, index) {
                return MediaSelect.mediaStartUploadWithId({
                  rootTag: rootTag,
                  id: videoId,
                  bizIdForUpload: MediaConstants.UploadBizId,
                  tokenForUpload: formatTokens[index]
                });
              });
              _context4.next = 5;
              return Promise.all(startUploadPromises);
            case 5:
              startUploadResults = _context4.sent;
              // 获得开始上传的结果
              startUploadResults.forEach(function () {
                // 添加上传状态监听
                addMediasListener(function (fileList) {
                  setOriginFileList(fileList); // 如果还有正在上传的就先不添加到form

                  var loadingList = fileList.find(function (item) {
                    return item.uploadStatus === UploadStatus.Loading;
                  });
                  if (loadingList !== undefined) {
                    return;
                  }
                  var succeddMeidaList = [];
                  var valueList = value.map(function (item) {
                    return item.url;
                  });
                  fileList.forEach(function (item) {
                    if (item !== null && item !== void 0 && item.file_name && item !== null && item !== void 0 && item.url && (item === null || item === void 0 ? void 0 : item.uploadStatus) === UploadStatus.Success && !valueList.includes(item.url)) {
                      succeddMeidaList.push({
                        file_name: item.file_name,
                        url: item.url
                      });
                    }
                  }); // 将成功上传的添加到form

                  onChange === null || onChange === void 0 ? void 0 : onChange([].concat(_toConsumableArray(value), succeddMeidaList).filter(function (item) {
                    return !!item;
                  })); // 如果所有都上传成功了就取消监听

                  if ((fileList === null || fileList === void 0 ? void 0 : fileList.length) > 0 && (fileList === null || fileList === void 0 ? void 0 : fileList.length) === (succeddMeidaList === null || succeddMeidaList === void 0 ? void 0 : succeddMeidaList.length)) {
                    var _MediaSelect$mediaSto;
                    MediaSelect === null || MediaSelect === void 0 ? void 0 : (_MediaSelect$mediaSto = MediaSelect.mediaStopListeningForUploadProgress) === null || _MediaSelect$mediaSto === void 0 ? void 0 : _MediaSelect$mediaSto.call(MediaSelect, rootTag);
                  }
                });
              });
              _context4.next = 12;
              break;
            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](0);
              console.error('[FileUpload] 视频上传失败', _context4.t0);
            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 9]]);
    }));
    return function handleVideoTokenResponse(_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
  var UploadImgUrl = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(img) {
      var imgItem, params, item;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              imgItem = {};
              _context5.prev = 1;
              // 获取图片的本地路径
              params = getFileFromUrl(addFileProtocol(img.imageFilePath), FILE_NAME);
              _context5.next = 5;
              return callback === null || callback === void 0 ? void 0 : callback({
                file: params
              });
            case 5:
              item = _context5.sent;
              if (item !== null && item !== void 0 && item.file_name && item !== null && item !== void 0 && item.url) {
                imgItem = _objectSpread(_objectSpread({
                  id: img.id
                }, item), {}, {
                  uri: img.imageFilePath,
                  uploadStatus: UploadStatus.Success,
                  type: img.type
                });
              } else {
                imgItem = {
                  id: img.id,
                  uri: img.url,
                  uploadStatus: UploadStatus.Fail
                };
              }
              _context5.next = 12;
              break;
            case 9:
              _context5.prev = 9;
              _context5.t0 = _context5["catch"](1);
              console.error('[FileUpload] 照片上传失败', _context5.t0);
            case 12:
              return _context5.abrupt("return", imgItem);
            case 13:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[1, 9]]);
    }));
    return function UploadImgUrl(_x9) {
      return _ref5.apply(this, arguments);
    };
  }();
  var handleMediaUpload = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(result) {
      var imgCount, videoCount, videoIds, originFiles, fileList, preUploadResult, succeddMeidaList;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              if (!(result.error !== UploadMediaResStatus.Success)) {
                _context7.next = 3;
                break;
              }
              return _context7.abrupt("return");
            case 3:
              imgCount = ((result === null || result === void 0 ? void 0 : result.data) || []).filter(function (i) {
                return i.type === MediaType.Image;
              }).length;
              videoCount = ((result === null || result === void 0 ? void 0 : result.data) || []).filter(function (i) {
                return i.type === MediaType.Video;
              }).length;
              videoIds = []; // 分别处理图片和视频

              _context7.next = 8;
              return Promise.all(((result === null || result === void 0 ? void 0 : result.data) || []).map( /*#__PURE__*/function () {
                var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(file) {
                  var imgItem;
                  return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                      switch (_context6.prev = _context6.next) {
                        case 0:
                          if (!(file.status === UploadMediaStatus.CompressFailed)) {
                            _context6.next = 2;
                            break;
                          }
                          return _context6.abrupt("return", {
                            id: file.id,
                            uploadStatus: UploadStatus.Fail
                          });
                        case 2:
                          if (!(file.type === MediaType.Image)) {
                            _context6.next = 9;
                            break;
                          }
                          _context6.next = 5;
                          return UploadImgUrl(file);
                        case 5:
                          imgItem = _context6.sent;
                          return _context6.abrupt("return", imgItem);
                        case 9:
                          if (!(file.type === MediaType.Video)) {
                            _context6.next = 12;
                            break;
                          }

                          // 获取视频id
                          videoIds.push(file.id);
                          return _context6.abrupt("return", {
                            id: file.id,
                            type: file.type,
                            uploadStatus: UploadStatus.Loading
                          });
                        case 12:
                        case "end":
                          return _context6.stop();
                      }
                    }
                  }, _callee6);
                }));
                return function (_x11) {
                  return _ref7.apply(this, arguments);
                };
              }()));
            case 8:
              originFiles = _context7.sent;
              fileList = [].concat(_toConsumableArray(originFileList), _toConsumableArray(originFiles));
              originFileListRef.current = fileList;
              setOriginFileList(fileList); // 上传视频

              if (!(videoCount > 0)) {
                _context7.next = 20;
                break;
              }
              _context7.next = 15;
              return postVideoPreUpload === null || postVideoPreUpload === void 0 ? void 0 : postVideoPreUpload({
                amount: videoCount,
                channel: 1,
                sessionId: sessionId
              });
            case 15:
              preUploadResult = _context7.sent;
              _context7.next = 18;
              return handleVideoTokenResponse(preUploadResult, videoIds);
            case 18:
              _context7.next = 21;
              break;
            case 20:
              if (imgCount > 0) {
                // 只有图片
                succeddMeidaList = [];
                fileList.forEach(function (item) {
                  if (item !== null && item !== void 0 && item.file_name && item !== null && item !== void 0 && item.url && (item === null || item === void 0 ? void 0 : item.uploadStatus) === UploadStatus.Success) {
                    succeddMeidaList.push({
                      file_name: item.file_name,
                      url: item.url
                    });
                  }
                }); // 将成功上传的添加到form

                onChange === null || onChange === void 0 ? void 0 : onChange([].concat(_toConsumableArray(value), succeddMeidaList).filter(function (item) {
                  return !!item;
                }));
              }
            case 21:
              _context7.next = 26;
              break;
            case 23:
              _context7.prev = 23;
              _context7.t0 = _context7["catch"](0);
              console.error('[FileUpload] 上传失败', _context7.t0);
            case 26:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[0, 23]]);
    }));
    return function handleMediaUpload(_x10) {
      return _ref6.apply(this, arguments);
    };
  }();
  var nativeUpload = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(maxCount, actionCallback, type) {
      var _map;
      var map, _props$getCurRootTag2, res, uriList, fileList;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              map = (_map = {}, _defineProperty(_map, SelectType.Gallery, ImagePicker.pickImage), _defineProperty(_map, SelectType.Photos, ImagePicker.takePhoto), _map);
              _context8.prev = 1;
              _context8.next = 4;
              return map[type](props === null || props === void 0 ? void 0 : (_props$getCurRootTag2 = props.getCurRootTag) === null || _props$getCurRootTag2 === void 0 ? void 0 : _props$getCurRootTag2.call(props), {
                maxCount: maxCount,
                allowPreview: true
              });
            case 4:
              res = _context8.sent;
              uriList = res.uriList;
              _context8.next = 8;
              return Promise.all(uriList.map(function (i) {
                return getFileFromUrl(i, FILE_NAME);
              }));
            case 8:
              fileList = _context8.sent;
              actionCallback(fileList, maxCount);
              _context8.next = 15;
              break;
            case 12:
              _context8.prev = 12;
              _context8.t0 = _context8["catch"](1);
              console.error('ImagePicker.pickImage failed:', _context8.t0);
            case 15:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[1, 12]]);
    }));
    return function nativeUpload(_x12, _x13, _x14) {
      return _ref8.apply(this, arguments);
    };
  }();
  var getFileTypeAccepted = function getFileTypeAccepted(fileTypeAccept) {
    if (!fileTypeAccept || fileTypeAccept.length === 0) {
      return MediaSelectType.ImageAndVideo;
    }
    var isAllVideo = fileTypeAccept.every(function (item) {
      return VIDEO_TYPE.includes(item);
    });
    var isAllImage = fileTypeAccept.every(function (item) {
      return IMAGE_TYPE.includes(item);
    });
    if (isAllVideo) {
      return MediaType.Video;
    } else if (isAllImage) {
      return MediaType.Image;
    } else {
      return MediaSelectType.ImageAndVideo;
    }
  };
  var nativeMediaUpload = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(maxCount) {
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              MediaSelect.mediaSelect({
                rootTag: rootTag,
                source: MediaSourceType.AlbumAndCamera,
                mediaType: getFileTypeAccepted(fileTypeAccepted),
                maxSelectCount: maxCount,
                videoMiniDuration: 1,
                videoMaxSize: maxFileSize,
                bizIdForMediaSDK: MediaConstants.MediaBizId
              }).then( /*#__PURE__*/function () {
                var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(res) {
                  return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                      switch (_context9.prev = _context9.next) {
                        case 0:
                          _context9.next = 2;
                          return handleMediaUpload(res);
                        case 2:
                        case "end":
                          return _context9.stop();
                      }
                    }
                  }, _callee9);
                }));
                return function (_x16) {
                  return _ref10.apply(this, arguments);
                };
              }()).catch(function (error) {
                console.error('[FileUpload] media获取失败', error);
              });
            case 1:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));
    return function nativeMediaUpload(_x15) {
      return _ref9.apply(this, arguments);
    };
  }();
  var getImageSource = function getImageSource(file) {
    if (isCaseCreation) {
      return {
        uri: (file === null || file === void 0 ? void 0 : file.coverUrl) || (file === null || file === void 0 ? void 0 : file.url)
      };
    } else {
      if (Platform.OS === 'web') {
        return (file === null || file === void 0 ? void 0 : file.url) || (file === null || file === void 0 ? void 0 : file.uri);
      } else {
        return {
          uri: (file === null || file === void 0 ? void 0 : file.url) || (file === null || file === void 0 ? void 0 : file.uri)
        };
      }
    }
  };
  useEffect(function () {
    if (isCaseCreation) {
      var _dataMaintainer$track, _dataMaintainer$track2, _props$trackingData, _props$trackingData2, _props$trackingData3, _props$trackingData3$;
      (_dataMaintainer$track = dataMaintainer.tracker) === null || _dataMaintainer$track === void 0 ? void 0 : (_dataMaintainer$track2 = _dataMaintainer$track.dispatchTrack) === null || _dataMaintainer$track2 === void 0 ? void 0 : _dataMaintainer$track2.call(_dataMaintainer$track, {
        operation: TRACKING_OPERATION.IMPRESSION,
        section: (props === null || props === void 0 ? void 0 : (_props$trackingData = props.trackingData) === null || _props$trackingData === void 0 ? void 0 : _props$trackingData.trackingsection) || {},
        target: (props === null || props === void 0 ? void 0 : (_props$trackingData2 = props.trackingData) === null || _props$trackingData2 === void 0 ? void 0 : _props$trackingData2.trackingtarget) || {},
        data: (props === null || props === void 0 ? void 0 : (_props$trackingData3 = props.trackingData) === null || _props$trackingData3 === void 0 ? void 0 : (_props$trackingData3$ = _props$trackingData3.trackingdataBasic) === null || _props$trackingData3$ === void 0 ? void 0 : _props$trackingData3$.data) || {}
      });
    }
  }, []);
  return /*#__PURE__*/React.createElement(View, {
    style: styles.pictureUploadWrapper
  }, originFileList.length !== 0 ? /*#__PURE__*/React.createElement(React.Fragment, null, originFileList.map(function (file, index) {
    return /*#__PURE__*/React.createElement(View, {
      style: isCaseCreation ? styles.mediaWrapper : styles.imageWrapper,
      key: index
    }, /*#__PURE__*/React.createElement(Image, {
      style: isCaseCreation ? styles.mediaItem : styles.imageItem,
      source: getImageSource(file)
    }), ![ModeType.View].includes(props.mode) ? /*#__PURE__*/React.createElement(Pressable, {
      style: isCaseCreation ? styles.mediaRemoveIconWrapper : styles.imageRemoveIconWrapper,
      onPress: function onPress() {
        return handleRemove(index, file);
      }
    }, isCaseCreation ? /*#__PURE__*/React.createElement(MediaDelete, {
      style: styles.mediaRemoveIcon
    }) : /*#__PURE__*/React.createElement(CloseLine, {
      style: styles.imageRemoveIcon
    })) : null, isCaseCreation && file.uploadStatus === UploadStatus.Loading ? /*#__PURE__*/React.createElement(Pressable, {
      style: [styles.mediaMaskWrapper, styles.mediaLoadingMaskWrapper]
    }, /*#__PURE__*/React.createElement(Image, {
      style: styles.mediaLoadingIcon,
      source: Loading
    })) : null, isCaseCreation && file.uploadStatus === UploadStatus.Fail ? /*#__PURE__*/React.createElement(Pressable, {
      style: styles.mediaMaskWrapper,
      onPress: function onPress() {
        return handleRetry(index, file);
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: styles.failedIconWrapper
    }, /*#__PURE__*/React.createElement(UploadFailed, {
      style: styles.mediaFailedIcon
    })), /*#__PURE__*/React.createElement(Text, {
      style: styles.mediaFailedText
    }, "Retry")) : null, !isCaseCreation && file.uploadStatus === UploadStatus.Fail ? /*#__PURE__*/React.createElement(Pressable, {
      style: styles.maskWrapper,
      onPress: function onPress() {
        return handleRetry(index, file);
      }
    }, /*#__PURE__*/React.createElement(UploadFailed, {
      style: styles.failedIcon
    }), /*#__PURE__*/React.createElement(Text, {
      style: styles.failedText
    }, "Retry")) : null);
  })) : null, showUploadIcon ? /*#__PURE__*/React.createElement(TouchableOpacity, {
    onPress: handleUpload
  }, /*#__PURE__*/React.createElement(View, {
    ref: anchorRef,
    style: isCaseCreation ? styles.mediaUploadItemWrapper : styles.pictureUploadItemWrapper
  }, isCaseCreation ? /*#__PURE__*/React.createElement(View, {
    style: styles.mediaUploadIconWrapper
  }, /*#__PURE__*/React.createElement(AddIcon, {
    style: styles.mediaUploadIcon
  }), !!maxFileNum ? /*#__PURE__*/React.createElement(Text, {
    style: styles.mediaUploadText
  }, trans('case_creation_click_to_upload'), "(", originFileList.length, "/", maxFileNum, ")") : null) : /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Picture, {
    style: styles.pictureUploadIcon
  }), !!maxFileNum ? /*#__PURE__*/React.createElement(Text, {
    style: styles.pictureUploadText
  }, originFileList.length, "/", maxFileNum) : null))) : null);
};
export default module.exports;